import Super from 'client-portal/routes/-request/index';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetIndex extends Super {}
